<div class="row justify-content-center py-4 m-0">
  <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 m-0 p-0">
    <quick-preview-panel [heading]="'Active Session'" [color]="'warn'">
      <div class="p-4">
        <auth-user-account-info></auth-user-account-info>
      </div>
      <actions-container>
        <div class="my-4">
          <button color="warn" mat-raised-button class="me-2" (click)="logout()">
            Confirm Logout
          </button>
          <back-button class="me-4"></back-button>
        </div>
      </actions-container>
    </quick-preview-panel>
  </div>
</div>
